import { Box, Chip, Grid, Typography } from "@mui/material";

interface InfoFieldProps {
    label:          string;
    value:          React.ReactNode;
    chip?:          boolean;
    fontSize?:      number;
}

export const InfoField = ({ label, value, chip = false, fontSize = 16 }: InfoFieldProps) => {

    if ( chip ) {

        return (

            <Grid container spacing={3}>

                <Grid size={{ md: 6, xs: 12 }}>
              
                    <Typography variant="body2" sx={{ color: "black", fontSize: fontSize }}>
                        { label }:
                    </Typography>

                </Grid>
                
                <Grid size={{ md: 6, xs: 12 }}>

                    <Chip
                        label={ value }
                        sx={{
                            px: 2,
                            fontWeight: 500,
                            borderRadius: "99px",
                            maxWidth: 'none',
                            backgroundColor: "action.hover",
                            border: "0.5px solid",
                            borderColor: "divider",
                            color: "text.primary",
                        }}
                    />

                </Grid>

            </Grid>

        );

    }

    return (
        <Box>

            <Typography
                variant="subtitle2"
                sx={{
                    color: "text.secondary",
                    letterSpacing: 0.5,
                    fontWeight: 700,
                }}
            >
                { label }:
            </Typography>

            <Typography component='div' variant='h6' fontWeight={'bold'} fontSize={ fontSize }>
                { value }
            </Typography>

        </Box>
    );

};